import React, { useEffect } from 'react';

const ConfirmDialog = ({
    title = "Confirmación requerida",
    message,
    onConfirm,
    onCancel,
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    isOpen = false,
    variant = "primary",
    children
}) => {
    // Bloquear scroll cuando el modal está abierto
    useEffect(() => {
        if (isOpen) {
            // Guardar la posición actual del scroll
            const scrollY = window.scrollY;
            // Bloquear el scroll del body
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            
            return () => {
                // Restaurar el scroll cuando se cierra el modal
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-[var(--app-overlay)] flex items-center justify-center z-9998 p-4 modal-fade-in" role="dialog" aria-modal="true">
            <div className="bg-surface rounded-lg shadow-xl max-w-md w-full transition transform modal-scale-in">
                <div className="p-6 border-b border-line">
                    <h2 className="text-2xl font-semibold text-content">
                        {title}
                    </h2>
                </div>
                <div className="p-6 text-content">
                    {message && <p className="text-base leading-relaxed">{message}</p>}
                    {children}
                </div>
                <div className="p-6 border-t border-line flex justify-end gap-3">
                    <button
                        onClick={onCancel}
                        className="px-6 py-2.5 bg-surface-2 hover:bg-line text-content rounded-lg transition-colors font-medium"
                        type="button"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`px-6 py-2.5 rounded-lg transition-colors font-medium ${
                            variant === "danger" ? "bg-error hover:bg-error/80 text-content" : "bg-amber hover:bg-amber-hover text-on-amber"
                        }`}
                        type="button"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
